/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { equal } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { ever, recent, recentLimit, timesLimitExceededError } from 'cio/app-models/conditions/refinement';
import integerToString from 'cio/utils/integer-to-string';

import AnalyticsService from 'cio/services/analytics';
import RouterService from '@ember/routing/router-service';
import AuthService from 'cio/services/auth';

interface CioConditionEditorRefinementArgs {
  refinement: Record<string, any>;
  condition: Record<string, any>;
  disabled: boolean;
}

export default class CioConditionEditorRefinement extends Component<CioConditionEditorRefinementArgs> {
  @service analytics!: AnalyticsService;
  @service auth!: AuthService;
  @service router!: RouterService;

  periodOptions = [
    { value: ever, label: 'ever' },
    { value: recent, label: 'within the last' },
  ];

  @equal('args.refinement.period', recent) isRecent!: boolean;

  @action
  onTimesChange() {
    let { times: timesErrors } = this.args.refinement.errors;

    if (timesErrors?.includes(timesLimitExceededError)) {
      this.analytics.track('user', 'error_encountered', {
        message: timesLimitExceededError,
        currentUrl: this.router.currentURL,
      });
    }
  }

  @action
  updatePeriod(value: string) {
    if (value === recent && this.args.refinement.times > recentLimit) {
      this.args.refinement.set('times', recentLimit);
    }
  }

  @integerToString('args.refinement.days') days!: string;
  @integerToString('args.refinement.times') times!: string;

  get countLimit() {
    if (this.isRecent) {
      return recentLimit;
    }

    return;
  }
}
